import styled from 'styled-components'
import {ReactComponent as LogoSVG} from './logo.svg'
import {Marginals} from '../../styles'

/*export const Logo = styled(LogoSVG)`
  height: auto;
  max-width: 48rem;
  width: 100%;
`
*/

export const LogoOne = styled.h1.attrs(({textColor}) => ({
  style: {
    color: textColor
  }
}))`
  font-weight: 800;
  margin: 0.2em 0;
`
export const LogoTwo = styled.h1.attrs(({textColor}) => ({
  style: {
    color: textColor
  }
}))`
  font-weight: 500;
  font-family: 'Noto Serif Display', serif;
  margin: 0.2em 0;
`

export const Header = styled.header`
  ${Marginals}

  justify-content: center;

  font-size: 6vmin;
  line-height: 1;
  text-transform: uppercase;
`
